import React, { Component } from 'react';
import './AppPage.css';
import './dashboard_grid.css';

import BuildingDetails from 'components/tenant_app/components/building/BuildingDetails';
import BuildingContactDetails from 'components/tenant_app/components/building/BuildingContactDetails';
import Referrals from 'components/tenant_app/components/building/referrals/Referrals';

import { deepDiver } from 'helpers/utilities';

import * as tenantProfileActions from 'actions/tenantProfileActions';

import 'react-table/react-table.css';
import { connect } from 'react-redux';

const DEFAULT_ROW_HEIGHT = 279;

export default connect(
  store => ({
    showPage: store.authentication.showPage,
    building: store.tenantProfile.building,
    tenantOverview: store.dashboard.tenantOverview,
  }),
  {
    getBuildingInformation: tenantProfileActions.getBuildingInformation,
  }
)(
  class Building extends Component {
    UNSAFE_componentWillMount = () => {
      this.props.getBuildingInformation();
    };

    render() {
      return (
        <div
          className="body"
          role="main"
          ref="buildingContainer"
          style={{ backgroundColor: '#fdfdfd', borderLeft: '1px solid #f7f7f7' }}
        >
          <div className="centers">
            <div style={{ padding: '0 10px' }}>
              <h2 style={{ margin: '0 0 15px 0' }}>My Building</h2>
              <div className="my-building-grid">
                <BuildingDetails
                  defaultHeight={DEFAULT_ROW_HEIGHT}
                  building={this.props.building}
                />
                <BuildingContactDetails building={this.props.building} />

                {this._renderReferrals()}
              </div>
              <div style={{ height: '100px' }} />
            </div>
          </div>
        </div>
      );
    }

    _renderReferrals = () => {
      if (deepDiver(this.props.tenantOverview, 'property_type') === 'industrial') return;

      return <Referrals />;
    };
  }
);
